
export const FetchOptions = {
    credentials: "same-origin",
    cache: "no-store",
}
